import { KoPagination, KoTable } from 'packages';
import React, { useState } from 'react';



const ROWS = [
  {
    id: "TC-9802",
    subject: "Delivery was delayed",
    priority: "Medium",
    type: "Shipping",
    request: "14 Jan 2024",
    time: "10:00"
  },
  {
    id: "TC-9802",
    subject: "Payment status does n…",
    priority: "Low",
    type: "Payment",
    request: "14 Jan 2024",
    time: "10:00"
  },
  {
    id: "TC-9802",
    subject: "Payment status does n…",
    priority: "Medium",
    type: "Payment",
    request: "14 Jan 2024",
    time: "10:00"
  },
  {
    id: "TC-9802",
    subject: "Delivery was delayed",
    priority: "Low",
    type: "Shipping",
    request: "14 Jan 2024",
    time: "10:00"
  },
  {
    id: "TC-9802",
    subject: "Damaged or missing p…",
    priority: "Low",
    type: "Product",
    request: "14 Jan 2024",
    time: "10:00"
  },
  {
    id: "TC-9802",
    subject: "Unable to sign up",
    priority: "High",
    type: "Account",
    request: "14 Jan 2024",
    time: "10:00"
  },
  {
    id: "TC-9802",
    subject: "Delivery was delayed",
    priority: "Medium",
    type: "Shipping",
    request: "14 Jan 2024",
    time: "10:00"
  },
  {
    id: "TC-9802",
    subject: "Payment status does n…",
    priority: "Low",
    type: "Payment",
    request: "14 Jan 2024",
    time: "10:00"
  },
  {
    id: "TC-9802",
    subject: "Payment status does n…",
    priority: "Medium",
    type: "Payment",
    request: "14 Jan 2024",
    time: "10:00"
  },
  {
    id: "TC-9802",
    subject: "Delivery was delayed",
    priority: "Low",
    type: "Shipping",
    request: "14 Jan 2024",
    time: "10:00"
  },
  {
    id: "TC-9802",
    subject: "Damaged or missing p…",
    priority: "Low",
    type: "Product",
    request: "14 Jan 2024",
    time: "10:00"
  },
  {
    id: "TC-9802",
    subject: "Unable to sign up",
    priority: "High",
    type: "Account",
    request: "14 Jan 2024",
    time: "10:00"
  }
];

const PRO_ITEMS_COLUMNS = [
  {
    id: "subject",
    label: "SUBJECT",
    width: 250,
    fixed: "left",
    widget: "mediaText"
  },
  { id: "priority", label: "PRIORITY", width: 150, widget: "number" },
  { id: "type", label: "TYPE", width: 150 },
  { id: "request", label: "REQUEST", width: 200, widget: "date" }
];
const CustomerTicket = () => {
  const [totalCount ] = useState(0);
  const [pagination, setPagination ] = useState({
    size: 100,
    page: 1
  });
  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page,
      offset: (page - 1) * other
    };
    const pQuery = Object.assign(pagination, query);
    setPagination(pQuery);
  };
  return (
    
    <div>
      <KoTable
        rowKey="id"
        minHeight={100}
        data={{
          columns: PRO_ITEMS_COLUMNS,
          rows: ROWS
        }}
      />
      <KoPagination current={parseInt(pagination.page) || 1}
        total={totalCount}
        showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} records`
        }
        pageSize={pagination.limit}
        defaultCurrent={pagination.page}
        onChange={onPagination}
        showQuickJumper={false}
        simple={false}
        responsive={false} />
    </div>
    
  );
};

export default CustomerTicket;